import axios from 'axios';

export const HTTP = axios.create({
  baseURL: 'https://tramites1.ebc.edu.mx/apiTitulacionElectronica',
})